<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["AN"][obj_asan.I > 0? "ESN": "ASAN"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol md="12">
                                            <div class="d-flex">
                                                <label for="asdw" class="col-form-label-sm mr-2">{{this.getLanguage["AN"]["ASDS"]}}</label>
                                                <input type="checkbox" id="asdw" v-model="bool_autoSelectDescendant" @click="autoSelectDescendant()">
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["AN"]["A"]}}<span class="required" /> :</label>
                                            <span v-if="!bool_SentAll">
                                                <customtreeselect :multiple="true"
                                                                  :flat="true"
                                                                  :options="dd_agentgroup"
                                                                  value-consists-of="ALL"
                                                                  :defaultExpandLevel="Infinity"
                                                                  :clearable="false"
                                                                  :disable-branch-nodes="false"
                                                                  :autoSelectDescendants=bool_autoSelectDescendant
                                                                  :autoDeselectDescendants=bool_autoSelectDescendant
                                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                                  :limit="1"
                                                                  :disabled="bool_SentAll"
                                                                  :limitText="count => `+${count}`"
                                                                  v-model="obj_asan['AGIT']"
                                                                  ref="AGIT"
                                                                  @input="AgentGroupChange" />
                                            </span>
                                            <span v-else><CInput maxlength="200" :readonly="true" size="sm" :placeholder="getLanguage['AN']['SA']" /></span>
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','A') }}</span>
                                        </CCol>
                                        <CCol md="6" v-if="this.getUserInfo.AT==0">
                                            <label class="col-form-label-sm">
                                                {{this.getLanguage["AN"]["SA"]}}
                                                <div class="custom-tooltip">
                                                <i class="fa fa-question-circle exclude"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["AN"]["SAUN"]}}</span>
                                                </div>:
                                            </label>
                                            <br>
                                            <label class="switch">
                                                <input :checked="bool_SentAll" @change="v => bool_SentAll = v.target.checked" type="checkbox" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol md="6" v-else></CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["AN"]["AT"]}}<span class="required" /> :</label>
                                            <span class="WCMsg" v-if="this.obj_asan.AT != null">{{ this.obj_asan.AT.length }} / 200 </span>
                                            <span class="WCMsg" v-else> 0 / 200 </span>
                                            <CInput maxlength="200" size="sm" :value="obj_asan.AT" @change="v => obj_asan.AT = v" ref="AT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AT','AT') }}</span>
                                        </CCol>
                                        <CCol md="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AN"]["L"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_lang"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :defaultExpandLevel="Infinity"
                                                        :placeholder="this.utilGetDDLanguage('AN.L')"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`"
                                                        v-model="obj_asan['Lang']"
                                                        ref="Lang">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    <span v-for="(data,index) in dd_lang[0].children" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                                    <span>{{ node.label }}</span>
                                                </div>
                                                <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                                    <span v-for="(data,index) in dd_lang[0].children" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                                    <span>{{ node.label }}</span>
                                                </div>
                                            </treeselect>
                                            <span class="ErrMsg">{{ ValidationErrMsg('Lang','L') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="checkModuleAccess('SPM', 'AN', 3)">
                                        <CCol md="6">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["AN"]["MNT"]}}? :</label><br>
                                            <div class="container">
                                                <div class="radio-tile-group">
                                                    <div class="input-container" v-show="bool_edit_showTickMM_button">
                                                        <input id="NoMaintenance" class="radio-button" type="radio" name="radio" :checked="obj_asan['TickNo']" @change="setAnnType('TickNo')" />
                                                        <div class="radio-tile">
                                                            <label for="NoMaintenance" class="radio-tile-label">{{this.getLanguage["DB"]["NOM"]}}</label>
                                                        </div>
                                                    </div>
                                                    <div class="input-container" v-show="bool_edit_showTick_button">
                                                        <input id="GameProvider" class="radio-button" type="radio" name="radio" :checked="obj_asan['Tick']" @change="setAnnType('Tick')" />
                                                        <div class="radio-tile">
                                                            <label for="GameProvider" class="radio-tile-label">{{this.getLanguage["CMS"]["GP"]}} {{this.getLanguage["AN"]["MNT"]}}</label>
                                                        </div>
                                                    </div>
                                                    <div class="input-container" v-show="bool_edit_showTickPM_button">
                                                        <input id="PaymentMethod" class="radio-button" type="radio" name="radio" :checked="obj_asan['TickPM']" @change="setAnnType('TickPM')" />
                                                        <div class="radio-tile">
                                                            <label for="PaymentMethod" class="radio-tile-label">{{this.getLanguage["AN"]["PC"]}} {{this.getLanguage["AN"]["MNT"]}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCol>
                                        <CCol md="6">
                                            <CRow>
                                                <CCol md="12" class="form-group" v-show="obj_asan['Tick']" v-if="checkModuleAccess('SPM', 'AN', 3)">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AN"]["GP"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :placeholder="this.utilGetDDLanguage('AN.GP')"
                                                                :load-options="loadProviderOptions"
                                                                :options="ddProviderList"
                                                                v-model="obj_asan['GPI']"
                                                                ref="GPI" />
                                                    <span class="ErrMsg">{{ ValidationErrMsg('GPI','GP') }}</span>
                                                </CCol>
                                                <CCol md="12" class="form-group" v-show="obj_asan['TickPM']" v-if="checkModuleAccess('SPM', 'AN', 3)">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AN"]["PC"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="true"
                                                                :options="dd_PaymentChannel"
                                                                :defaultExpandLevel="Infinity"
                                                                :clearable="false"
                                                                :placeholder="this.utilGetDDLanguage('AN.PC')"
                                                                :flat="false"
                                                                :limit="3"
                                                                v-model="obj_asan['PCS_array']"
                                                                ref="PCS_array" />
                                                    <span class="ErrMsg">{{ ValidationErrMsg('PCS_array','PC') }}</span>
                                                </CCol>
                                                <CCol md="6" v-show="obj_asan['Tick']||obj_asan['TickPM']">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AN"]["MSD"]}}<span class="required" /> :</label>
                                                    <date-range-picker :show-dropdowns="true"
                                                                       opens="left"
                                                                       :auto-apply="true"
                                                                       @update="defaultDateRangePickerUpdateEvent"
                                                                       v-model="dateMTS"
                                                                       :ranges="getDefaultDateRange()">
                                                        <div slot="input" slot-scope="picker">
                                                            <div v-if="dateMTS.startDate != ''">
                                                                <CInput size="sm"
                                                                        :value="dateMTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                        @change="DateTimeChange('AMSD',$event)" />
                                                            </div>
                                                            <div v-else>
                                                                <CInput size="sm"
                                                                        @change="DateTimeChange('AMSD',$event)" />
                                                            </div>
                                                        </div>
                                                    </date-range-picker>
                                                </CCol>
                                                <CCol md="6" v-show="obj_asan['Tick']||obj_asan['TickPM']">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AN"]["MED"]}}<span class="required" /> :</label>
                                                    <date-range-picker :show-dropdowns="true"
                                                                       opens="left"
                                                                       :auto-apply="true"
                                                                       @update="defaultDateRangePickerUpdateEvent"
                                                                       v-model="dateMTS"
                                                                       :ranges="getDefaultDateRange()">
                                                        <div slot="input" slot-scope="picker">
                                                            <div v-if="dateMTS.endDate != ''">
                                                                <CInput size="sm"
                                                                        :value="dateMTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                        @change="DateTimeChange('AMED',$event)" />
                                                            </div>
                                                            <div v-else>
                                                                <CInput size="sm"
                                                                        @change="DateTimeChange('AMED',$event)" />
                                                            </div>
                                                        </div>
                                                    </date-range-picker>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="6">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["AN"]["S"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_asan['HS']" @change="v => obj_asan['HS'] = v.target.checked" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol md="3" class="form-group" v-show="obj_asan['HS']">
                                            <label class="col-form-label-sm">{{this.getLanguage["GL"]["SD"]}}<span class="required" /> :</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="left"
                                                               :auto-apply="true"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               v-model="dateTS"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="dateTS.startDate != ''">
                                                        <CInput size="sm"
                                                                :value="dateTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('ASD',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('ASD',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                        </CCol>
                                        <CCol md="3" class="form-group" v-show="obj_asan['HS']">
                                            <label class="col-form-label-sm">{{this.getLanguage["GL"]["ED"]}}<span class="required" /> :</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="left"
                                                               :auto-apply="true"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               v-model="dateTS"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="dateTS.endDate != ''">
                                                        <CInput size="sm"
                                                                :value="dateTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('AED',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('AED',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="12">
                                            <label class="col-form-label-sm">{{this.getLanguage["AN"]["AC"]}}<span class="required" /> :</label>
                                            <textarea vertical="" rows="10" class="form-control form-control-sm" :value="obj_asan.AC" @change="TextValueChange('AC',$event)" v-shortkey.avoid ref="AC" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AC','AC') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveSAN()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_showUser">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["AN"]["VSAD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showUser = !bool_showUser">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol md="6">
                                            <label class="col-form-label-sm">{{this.getLanguage['AN']['AT']}} :</label>
                                            <CInput vertical size="sm" :value="obj_asan.AT" :disabled="true" />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol>
                                            <label class="col-form-label-sm">{{this.getLanguage['AN']['AC']}} :</label>
                                            <textarea vertical="" rows="6" class="form-control form-control-sm" :value="obj_asan.AC" :disabled="true" />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol :md="(obj_asan.AudienceList.length > 0 ? 6 : 12)" class="pt-3" v-if="obj_asan.LanguageList.length > 0">
                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                        <th>{{this.getLanguage['AN']['L']}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(lang,index) in obj_asan.LanguageList">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ lang }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                        <CCol :md="(obj_asan.LanguageList.length > 0 ? 6 : 12)" class="pt-3" v-if="obj_asan.AudienceList.length > 0">
                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                        <th>{{this.getLanguage['ASN']['BN']}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(data,index) in obj_asan.AudienceList">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ data.GN }} ({{ renderAgentGroupName(data.GN, data.GPC, data.AGI ) }})</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["AN"]["SAN"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addSAN()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AN"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AN"]["ATC"]}} :</span>
                                <CInput size="sm"
                                        :value="str_FV[0].FV"
                                        @change="v => str_FV[0].FV = v" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AN"]["L"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_langfs"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :limit="1"
                                            :defaultExpandLevel="Infinity"
                                            :limitText="count => `+${count}`"
                                            :placeholder="this.utilGetDDLanguage('AN.L')"
                                            v-model="str_FV[1].FV">
                                </treeselect>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AN"]["MNT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_status"
                                            :placeholder="this.utilGetDDLanguage('AN.MNT')"
                                            v-model="str_FV[4].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["AN"]["SAL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2">{{this.getLanguage["GL"]["NO"]}} </th>
                                <th rowspan="2" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th rowspan="2" v-if="checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add)">{{getLanguage["AFF"]["ACT"]}}</th>
                                <th rowspan="2" width="400px">{{this.getLanguage["AN"]["AT"]}}<i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i></th>
                                <th colspan="2" id="nestedTable" style=" border-right: 1.5px solid rgb(157, 157, 171); border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["AN"]["S"]}}</th>
                                <th rowspan="2" v-if="checkModuleAccess2(constAccessType.edit)">{{this.getLanguage["AN"]["A"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" style=" border-right: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["AN"]["FR"]}}</th>
                                <th id="nestedTableR2" style=" border-right: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["AN"]["TO"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2">{{this.getLanguage["GL"]["NO"]}} </th>
                                <th rowspan="2" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th rowspan="2" v-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add))">{{getLanguage["AFF"]["ACT"]}}</th>
                                <th rowspan="2" width="400px">{{this.getLanguage["AN"]["AT"]}}<i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i></th>
                                <th colspan="2" id="nestedTable" style=" border-right: 1.5px solid rgb(157, 157, 171); border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["AN"]["S"]}}</th>
                                <th rowspan="2" v-if="checkModuleAccess2(constAccessType.edit)">{{this.getLanguage["AN"]["A"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" style=" border-right: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["AN"]["FR"]}}</th>
                                <th id="nestedTableR2" style=" border-right: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["AN"]["TO"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_san.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_san" :class="renderStatus(data.status)">
                            <td>{{ CountItem(index+1) }} <span v-if="((data.Tick) || (data.TickPM))">&#128679;</span></td>
                            <td v-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-trash" @click="removeSAN(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                        <i class="cil-trash"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-color-border" @click="editSAN(data.I)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div v-else-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td v-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add))">
                                <span v-if="checkStatus(data)==true && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <CCol col="4">
                                        <label class="switch">
                                            <input type="checkbox" true-value="2" false-value="1" v-model="data.RS" @click="updateSANStatus(data)">
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                </span>
                                <span v-else-if="checkStatus(data)==true && (isSENS == 1 && data.AGI != curAGI)">
                                    <CCol col="4">
                                        <label class="switch">
                                            <input type="checkbox" true-value="2" false-value="1" v-model="data.RS">
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                </span>
                                <span v-else>
                                    {{getLanguage["AN"]["E"]}}
                                </span>
                            </td>
                            <td class='kema-eft' @click="ViewSAN(data.I)">
                                {{ substrContent(data.AT, 60) }}
                                <br>
                                <p class="kema-eft annC" style="width:400px">"{{ substrContent(data.AC, 200) }}"</p>
                            </td>
                            <td v-if="data.HS == false">{{getLanguage["AN"]["IN"]}}</td>
                            <td v-else>{{ formatDateTime(data.STS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td v-if="data.HS == false">{{getLanguage["AN"]["IN"]}}</td>
                            <td v-else>{{ formatDateTime(data.ETS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)" class='kema-eft' @click="ViewSAN(data.I)">
                                <span class="grid-line">{{getLanguage["GL"]["VD"]}}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_edit_showTickPM_button: true,
                bool_edit_showTick_button: true,
                bool_edit_showTickMM_button: true,
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_showUser: false,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "R", //(sort the table col name)
                bool_isSort: false,
                bool_SentAll: false,
                bool_autoSelectDescendant: true,
                str_FV: [{ F: "ATC" }, { F: "L_csv", FA: true }, { F: "AGI", FA: true }, {
                    F: "STS", FV: {
                        startDate: "",
                        endDate: ""
                    }
                }, { F: "MGPI" }], //Filter Value
                arry_san: [], //system annoucement list
                obj_asan: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AT: null,
                    AC: null,
                    Lang: null,
                    L: "",
                    STS: null,
                    ETS: null,
                    MSTS: null,
                    METS: null,
                    HS: false,
                    LAGI: "",
                    AGIT: null,
                    PCS: "", //PaymentChannelS
                    PCS_array: null,
                    GA: "",
                    Tick: false,
                    TickPM: false,
                    TickNo: true,
                    IsSentAll: false,
                    GPI: 0,
                    BGPI: 0,
                }, // add system annoucement
                dd_langfs: [],//language option
                obj_Post: {
                    SelectedBrands: [] //to store multiple brand and post data to api
                },
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option for search
                dd_PaymentChannel: [], //dd_PaymentChannel option
                dd_lang: [],
                dd_status: [],
                //dd_status: [{ id: "1", label: "Maintenance" }, { id: "0", label: "No Maintenance" }],
                ddProviderList: null,
                constAccessType: constAccessType,
                dateTS: {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                },
                dateMTS: {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                }
            }
        },
        validations: {
            obj_asan: {
                AGIT: { required },
                AT: { required },
                AC: { required },
                Lang: { required },
                GPI: {
                    required: requiredIf(function (vm) {
                        return vm.Tick;
                    }),
                },
                PCS_array: {
                    required: requiredIf(function (vm) {
                        return vm.TickPM;
                    }),
                }

            }
        },
        created() {
            this.$parent.showSubMenu = 'AN';
            this.$parent.showActiveMenu = 'AN.SAN';

            this.str_FV[0].FV = this.$route.query.fr;

            this.getSANList();
            this.getLangauge();
            this.getAgentGroup();
            this.getDropdownList();
            this.getGetPaymentChannel();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.getStatus();

        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('UserInfo', ['getUserInfo']),
        },
        watch: {
            'obj_asan.AGIT': {
                handler(newVal) {
                    if (newVal && newVal.length != 0) {} else
                    {
                        this.dd_lang = this.dd_langfs;
                    }
                }
            },
            'bool_SentAll': {
                handler(newVal)
                {
                    if (newVal) {
                         this.dd_lang = this.dd_langfs;
                    } else
                    {
                        this.AgentGroupChange(this.obj_asan.AGIT);
                    }
                }
            },
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getSANList();
                this.getStatus();
            }
        },
        methods: {
            AgentGroupChange(value) {
                var that = this;
                var agiList = [];
                if (value && value.length > 0) {
                    for (var i = 0; i < value.length; i++) {
                        var agi = value[i].split("-");
                        agiList.push(agi[1]);
                    }
                    this.obj_Post.SelectedBrands = agiList;
                    this.postDataApi(`/api/dd/langbyaglist`, this.obj_Post,
                        function (d, s) {
                            if (s) {
                                that.dd_lang = that.appendSelectAllOption(d.dropdownlist);
                                if (that.bool_SentAll || that.obj_asan.AGIT == null) {
                                    that.dd_lang = that.dd_langfs;
                                }
                            }
                        });
                }
            },
            getDropdownList() {
                var that = this;

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            //if (that.dd_agentgroupfs.length > 0) {
                            //    that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            //}

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            //if (that.dd_agentgroup.length > 0) {
                            //    that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            //}

                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            setAnnType(which) {

                if (which == "Tick") {
                    this.obj_asan['Tick'] = true;
                    this.obj_asan['TickPM'] = false;
                    this.obj_asan['TickNo'] = false;

                    if (this.obj_asan['I'] > 0) { // if edit

                        if (this.obj_asan['GPI'] != 0) {
                            this.bool_edit_showTickPM_button = false;
                        }
                        else {
                            this.bool_edit_showTickPM_button = true;
                        }

                        if (this.obj_asan['GPI'] != null) {
                            this.bool_edit_showTickPM_button = false;
                        }
                        else {
                            this.bool_edit_showTickPM_button = true;
                        }

                    }
                    else {
                        this.obj_asan['PCS_array'] = null;
                    }
                }
                else if (which == "TickPM") {
                    this.obj_asan['TickPM'] = true;
                    this.obj_asan['Tick'] = false;
                    this.obj_asan['TickNo'] = false;

                    if (this.obj_asan['I'] > 0) { // if edit
                        if (this.obj_asan['GPI'] != 0) {
                            this.bool_edit_showTick_button = false;
                        }
                        else {
                            this.bool_edit_showTick_button = true;
                        }

                        if (this.obj_asan['GPI'] != null) {
                            this.bool_edit_showTick_button = false;
                        }
                        else {
                            this.bool_edit_showTick_button = true;
                        }

                    }
                    else {
                        this.obj_asan['GPI'] = null;

                    }
                }
                else if (which == "TickNo") {
                    this.obj_asan['TickNo'] = true;
                    this.obj_asan['TickPM'] = false;
                    this.obj_asan['Tick'] = false;
                    if (this.obj_asan['I'] <= 0) { // if not edit
                        this.obj_asan['PCS_array'] = null;
                        this.obj_asan['GPI'] = null;
                    }
                }
            },
            autoSelectDescendant() {
                if (!this.bool_autoSelectDescendant) {
                    this.bool_autoSelectDescendant = true;
                } else {
                    this.bool_autoSelectDescendant = false;
                }
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[3].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[3].FV.endDate = "";
                    }
                }
                if (type == "ASD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dateTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.dateTS.startDate = "";
                    }
                }
                if (type == "AED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dateTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.dateTS.endDate = "";
                    }
                }

                if (type == "AMSD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dateMTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.dateMTS.startDate = "";
                    }
                }
                if (type == "AMED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dateMTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.dateMTS.endDate = "";
                    }
                }
            },
            AgentGroupChangefs(value) {
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    that.str_FV[2].FV = agi;
                }
                else {
                    this.str_FV[2].FV = null;
                }
            },
            TextValueChange(type, event) {
                if (type == "AC") {
                    this.obj_asan.AC = event.target.value;
                }
            },
            renderAgentGroupName(GN, GPC, AGI) {
                if (AGI == 0) {
                    return this.getLanguage["AN"]["SAUN"];
                }
                else {
                    return GN + "(" + GPC + ")";
                }
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameProv`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                            }

                            that.ddProviderList = d.dropdownlist;
                        }
                        else {
                            that.ddProviderList = null;
                        }

                        callback();
                    });
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('SAN', 'AN', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
                this.obj_asan.AGIT = null;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getSANList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getSANList();
                }
            },
            getLangauge() {
                var that = this;
                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_lang =  that.appendSelectAllOption(d.dropdownlist);
                            that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
                        }

                    });
                var agi = this.getUserInfo.AGI;
                if (this.getUserInfo.AT < 3)
                    agi = 0;
                this.getDataApi(`/api/dd/lang/` + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
                            that.dd_lang = that.appendSelectAllOption(d.dropdownlist);
                        }

                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });
            },
            getGetPaymentChannel() {
                var that = this;
                this.getDataApi(`/api/dd/gpcc`,
                    function (d, s) {
                        if (s) {
                            that.dd_PaymentChannel = that.deepClone(d.dropdownlist);
                        }
                    });
            },
            getSANList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                            var value = this.str_FV[i].FV;

                            path += "f[AGI]=" + value;

                        }
                        else if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                var split = this.str_FV[i].FV[x].split("-");

                                if (split.length == 2) {
                                    temp_ += split[1];
                                }
                                else {
                                    temp_ += split[0];
                                }
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'STS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "" && this.str_FV[i].FV.endDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);

                                var full = cts_from + "," + cts_to;
                                path += ("f[STS_drsft]=" + full + "&f[ETS_dreft]=" + full);
                            }
                        }
                        else if (this.str_FV[i].F == 'MGPI' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV == '1') {
                                path += ("f[GPI_from]=1");
                            } else if (this.str_FV[i].FV == '0') {
                                path += ("f[GPI_to]=0");
                            }

                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };
                this.getDataApi(`/api/aann/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setSANList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setSANList(data) {
                this.arry_san = data.Items;                
                this.int_TP = Math.max(data.TotalPages, 1);
                this.int_TI = data.TotalItems;
            },
            setSAN(data) {
                this.obj_asan = Object.assign(this.obj_asan, data);

                this.obj_asan["BGPI"] = this.obj_asan["GPI"];
                this.obj_asan["Lang"] = this.obj_asan["L"].split(",");
                if (this.obj_asan.PCS != null && this.obj_asan.PCS.length > 0) {
                    this.obj_asan["PCS_array"] = this.obj_asan["PCS"].split(",");
                }

                this.bool_edit_showTick_button = true;
                this.bool_edit_showTickPM_button = true;
                this.bool_edit_showTickMM_button = true;

                var agi = [];
                if (this.obj_asan.AudienceList != null && this.obj_asan.AudienceList.length > 0) {
                    for (var i = 0; i < this.obj_asan.AudienceList.length; i++) {
                        if (this.obj_asan.AudienceList[i].AT == null) {
                            this.obj_asan.AudienceList[i].AT = 0;
                        }
                        agi.push(this.obj_asan.AudienceList[i].AT + "-" + this.obj_asan.AudienceList[i].AGI)
                    }
                }

                if (agi.length == 1) {
                    if (agi[0] == '0-0') {
                        this.bool_SentAll = true;
                        this.obj_asan.IsSentAll = true;
                        agi = [];
                    }
                    else {
                        this.bool_SentAll = false;
                        this.obj_asan.IsSentAll = false;
                    }
                }
                this.AgentGroupChange(agi);
                this.obj_asan.AGIT = agi;

                var PCS_temp = [];
                if (this.obj_asan.PCS != null && this.obj_asan.PCS.length > 0) {
                    var temp = this.obj_asan.PCS.split(",");
                    for (var i = 0; i < temp.length; i++) {
                        PCS_temp.push(temp[i]);
                    }
                }
                this.obj_asan.PCS_array = PCS_temp;

                if (this.obj_asan["HS"]) {
                    this.dateTS.startDate = this.obj_asan.STS;
                    this.dateTS.endDate = this.obj_asan.ETS;
                }
                else {
                    this.dateTS.startDate = this.getTodayDate();
                    this.dateTS.endDate = this.getTodayEndDate();
                }

                if (this.obj_asan["TickPM"] || this.obj_asan["Tick"]) {
                    this.dateMTS.startDate = this.obj_asan.MSTS;
                    this.dateMTS.endDate = this.obj_asan.METS;
                }
                else {
                    this.obj_asan["GPI"] = null;
                    this.dateMTS.startDate = this.getTodayDate();
                    this.dateMTS.endDate = this.getTodayEndDate();
                }


                if ((!this.obj_asan["Tick"]) && (!this.obj_asan["TickPM"])) {
                    this.setAnnType('TickNo');
                    this.bool_edit_showTick_button = false;
                    this.bool_edit_showTickPM_button = false;
                    this.bool_edit_showTickMM_button = true;
                }
                else if (this.obj_asan["TickPM"]) {
                    this.setAnnType('TickPM');
                    this.bool_edit_showTick_button = false;
                    this.bool_edit_showTickPM_button = true;
                    this.bool_edit_showTickMM_button = false;
                }
                else if (this.obj_asan["Tick"]) {
                    this.setAnnType('Tick');
                    this.bool_edit_showTick_button = true;
                    this.bool_edit_showTickPM_button = false;
                    this.bool_edit_showTickMM_button = false;
                }

                this.bool_isAMV = true;
            },
            setSAN_V(data) {
                this.obj_asan = Object.assign(this.obj_asan, data);
                this.bool_showUser = true;
            },
            addSAN() {
                this.bool_edit_showTick_button = true;
                this.bool_edit_showTickPM_button = true;
                this.bool_edit_showTickMM_button = true;

                this.obj_asan = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AT: null,
                    AC: null,
                    Lang: null,
                    L: "",
                    STS: null,
                    ETS: null,
                    HS: false,
                    LAGI: "",
                    AGIT: null,
                    PCS_array: null, //PaymentChannelS
                    PCS: "",
                    GA: "",
                    Tick: false,
                    TickPM: false,
                    TickNo: true,
                    GPI: null,
                    MSTS: null,
                    METS: null,
                };
                this.bool_CV = false;
                this.bool_isAMV = true;
                this.bool_SentAll = false;
                this.dateTS.startDate = this.getTodayDate();
                this.dateTS.endDate = this.getTodayEndDate();
                this.dateMTS.startDate = this.getTodayDate();
                this.dateMTS.endDate = this.getTodayEndDate();

                var agi = [];
                if (this.dd_agentgroup[0].children == undefined) {
                    agi.push(this.dd_agentgroup[0].id);

                }
                this.obj_asan.AGIT = agi;



            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {

                    var validateObj = this.$v.obj_asan[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AN"][langKey]);
                    }
                }

            },
            SetAGIT(item, index) {
                this.obj_asan.AGIT.push(item.id)
                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.SetAGIT);
                }
            },
            saveSAN() {
                this.bool_CV = true;
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;

                if (this.bool_SentAll) {
                    this.obj_asan.AGIT = [];
                    this.obj_asan.AGIT = ['0-0'];
                    //  this.dd_agentgroup.forEach(this.SetAGIT);
                    //  var sentAllAGI = [];
                    //  sentAllAGI.push(0-0);
                    this.obj_asan.IsSentAll = true;
                }
                else {
                    this.obj_asan.IsSentAll = false;
                }

                this.$v.obj_asan.$touch();
                if (!this.$v.obj_asan.$error) {

                    this.obj_asan['RS'] = 2;

                    if (this.obj_asan["HS"]) {
                        this.obj_asan["STS"] = this.parseDateToJsonString(this.dateTS.startDate);
                        this.obj_asan["ETS"] = this.parseDateToJsonString(this.dateTS.endDate);
                    }
                    else {
                        this.obj_asan["STS"] = this.parseDateToJsonString(this.getMinimumDate());
                        this.obj_asan["ETS"] = this.parseDateToJsonString(this.getMaximumDate());
                    }


                    if (this.obj_asan["Tick"]) {
                        this.obj_asan["MSTS"] = this.parseDateToJsonString(this.dateMTS.startDate);
                        this.obj_asan["METS"] = this.parseDateToJsonString(this.dateMTS.endDate);
                    }
                    else if (this.obj_asan["TickPM"]) {
                        this.obj_asan["MSTS"] = this.parseDateToJsonString(this.dateMTS.startDate);
                        this.obj_asan["METS"] = this.parseDateToJsonString(this.dateMTS.endDate);
                    }
                    else {
                        this.obj_asan["GPI"] = 0;
                        this.obj_asan["MSTS"] = null;//this.parseDateToJsonString(this.getMinimumDate());
                        this.obj_asan["METS"] = null;//this.parseDateToJsonString(this.getMaximumDate());
                    }

                    if (this.obj_asan["PCS_array"] != null) {
                        var temp_PCS = "";
                        for (var i = 0; i < this.obj_asan["PCS_array"].length; i++) {
                            if (i != 0) {
                                temp_PCS += ",";
                            }
                            temp_PCS += this.obj_asan.PCS_array[i];
                        }
                        this.obj_asan["PCS"] = temp_PCS;
                    }

                    var temp_lang = "";
                    for (var i = 0; i < this.obj_asan["Lang"].length; i++) {
                        if (i != 0) {
                            temp_lang += ",";
                        }
                        temp_lang += this.obj_asan.Lang[i];
                    }
                    this.obj_asan["L"] = temp_lang;


                    var agi = [];
                    if (this.obj_asan.AGIT != null && this.obj_asan.AGIT.length > 0) {
                        for (var i = 0; i < this.obj_asan.AGIT.length; i++) {
                            var temp = this.obj_asan.AGIT[i].split("-");
                            agi.push(temp[1])
                        }
                    }
                    this.obj_asan.LAGI = agi;
                    var that = this;

                    this.postDataApi(`/api/aann/s`, this.obj_asan,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getSANList();

                            }
                        });
                } else {
                    this.bool_fullLoading = false;
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_asan"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            editSAN(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/aann/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setSAN(d.D);
                        }
                    });
            },
            ViewSAN(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/aann/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setSAN_V(d.D);
                        }
                    });
            },
            checkStatus(data) {
                if (data.ETS > moment().format("YYYY-MM-DD HH:mm:ss")) {
                    return true;
                }
                else {
                    return false;
                }
            },
            updateSANStatus(data) {
                this.$fire({
                    title: this.getLanguage["AN"]["USM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        this.postDataApi(`/api/aann/saac`, data,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getSANList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                    else {
                        this.getSANList();
                    }
                });
            },
            removeSAN(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: data.I,
                            uts: data.UTS
                        };

                        this.postDataApi(`/api/aann/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getSANList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            renderStatus(index) {

                if (index) {
                    return "ActiveAnn-row";
                } else {
                    return "";
                }

            },

            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getSANList();
            },
            setFlag(languageCode) {
                return this.mapLanguageFlag(languageCode);
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[3].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);

                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const allHeaderRows = this.$el.querySelectorAll('#tHead .custom-table thead tr');

                if (!allHeaderRows.length) return; // Early return if no header rows

                tables.forEach((table) => {
                    let nestedIndex = 0;

                    // Collect body cells from the first row
                    const bodyCells = Array.from(table.querySelectorAll('tbody tr:first-child td'));
                    if (!bodyCells.length) return; // Early return if no body cells

                    // Reset all widths before applying new ones
                    const bodyCellElements = table.querySelectorAll('tbody tr td');
                    [...allHeaderRows[0].querySelectorAll('th'), ...bodyCellElements].forEach(cell => cell.style.width = '');

                    // Apply widths to header and body cells
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        const isNested = [4, 5].includes(index);
                        const headerRow = isNested ? 2 : 1;
                        const headerCells = this.$el.querySelectorAll(`#tHead .custom-table thead tr:nth-child(${headerRow}) th`);

                        let headerCell = headerCells[isNested ? nestedIndex : index];

                        // Special case for index 6
                        if (index === 6) {
                            headerCell = headerCells[5];
                        }

                        // Update header cell styles
                        if (headerCell) {
                            headerCell.style.width = width;
                        }

                        // Update body cell styles for the corresponding column
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach((td) => {
                            td.style.width = width;
                        });

                        // Increment nestedIndex for nested columns
                        if (isNested) nestedIndex++;
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            getStatus() {
                this.dd_status = [{ id: "1", label: this.getLanguage['DB']['DBM'] }, { id: "0", label: this.getLanguage['DB']['NOM'] }];
            }

        },
    }

</script>

<style scoped>
    /*
    * {
        box-sizing: border-box;
        font-family: "Helvetica Neue", sans-serif;
    }
    */

  /*  *:not(.exclude) {
        box-sizing: border-box;
        font-family: "Helvetica Neue", sans-serif;
    }*/

    /* Style to all li element except todo class name */
    li:not(.todo) {
        text-decoration: line-through;
        color: green;
    }

    .container {
        display: flex;
        justify-content: center;
        align-items: center;
        white-space: normal !important;
    }

    .radio-tile-group {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

        .radio-tile-group .input-container {
            position: relative;
            height: 4rem;
            width: 6.8rem;
            margin: 0.4rem;
        }

            .radio-tile-group .input-container .radio-button {
                opacity: 0;
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                margin: 0;
                cursor: pointer;
            }

            .radio-tile-group .input-container .radio-tile {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                border: 2px solid #425370;
                border-radius: 4px;
                padding: 1rem;
                transition: transform 300ms ease;
            }

            .radio-tile-group .input-container .icon svg {
                fill: #425370;
                width: 3rem;
                height: 3rem;
            }

            .radio-tile-group .input-container .radio-tile-label {
                text-align: center;
                font-size: 0.7rem;
                font-weight: 400;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                color: #425370;
            }

            .radio-tile-group .input-container .radio-button:checked + .radio-tile {
                background-color: #425370;
                border: 2px solid #425370;
                color: white;
                transform: scale(1.1, 1.1);
            }

                .radio-tile-group .input-container .radio-button:checked + .radio-tile .icon svg {
                    fill: white;
                    background-color: #425370;
                }

                .radio-tile-group .input-container .radio-button:checked + .radio-tile .radio-tile-label {
                    color: white;
                    background-color: #425370;
                }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Announcement/SystemAnnouncement.vue